import React from 'react';
import PropTypes from 'prop-types';
import { FcLike } from 'react-icons/fc';
import { IoMdHeartEmpty } from 'react-icons/io';
import { mutateFetchVideoById } from '../../../data/swrs/videos';
import toast from 'react-hot-toast';
import api from '../../../data/api';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '../../../data/atoms/utilsAtoms';

const SaveButton = ({ videoId, isSaved }) => {
	const userData = useAtomValue(userInfoAtom);

	const onSaveToggle = async (id, isVideoSaved) => {
		try {
			const apiMethod = isVideoSaved ? api.unsaveWishlist : api.saveWishlist;
			const response = await apiMethod(id, userData.token);

			if (response.status === 200) {
				await mutateFetchVideoById(id, userData.token);
			}
		} catch (error) {
			console.error('Error updating wishlist: ', error);
			toast.error('Failed to update wishlist. Please try again later.');
		}
	};

	return (
		<li onClick={() => onSaveToggle(videoId, isSaved)}>
			<a className="c-video-button">
				<p>
					<span id={videoId}>{isSaved ? <FcLike size={20} /> : <IoMdHeartEmpty size={20} />}</span>
				</p>
				<p className="c-mobile-text">{isSaved ? 'Saved' : 'Save'}</p>
			</a>
		</li>
	);
};

SaveButton.propTypes = {
	videoId: PropTypes.string.isRequired,
	isSaved: PropTypes.bool
};

SaveButton.defaultProps = {
	isSaved: false
};

export default SaveButton;
